/* eslint-disable class-methods-use-this */
import GradeMasterCollection from '../collection/GradeMasterCollection';
import * as marietta from '../..';
import MasterItemCollection from '../collection/MasterItemCollection';

/**
 * 付帯工事マスタの型定義
 */
export default interface auxiliaryMaster {
  company: auxiliaryMiddleCategory[];
  default: auxiliaryMiddleCategory[];
}
/**
 * 付帯工事マスタの中項目
 */
export interface auxiliaryMiddleCategory {
  middle_category_name: string;
  sub_categories: auxiliarySubCategory[];
}
/**
 * 付帯工事マスタの中項目のサブカテゴリ
 */
export interface auxiliarySubCategory {
  sub_category_name: string;
  auxiliary_constructions: auxiliaryConstructions[];
}
/**
 * 付帯工事マスタの細項目
 */
export interface auxiliaryConstructions {
  id: string;
  unit: string;
  unit_price: number;
  name: string;
  other_flag: number;
}

/**
 * 修繕理由マスタの型定義
 */
export default interface repairMaster {
  repair_reasons: repairReasons[]
}

interface repairReasons { name: string, id: string };

export default class MasterManager {
  // グレード一覧
  _grades:GradeMasterCollection[] = [];
  get GRADES():GradeMasterCollection[] {
    return this._grades;
  }
  set GRADES(list:GradeMasterCollection[]) {
    this._grades = list;
  }

  //共通項コード
  SYMBOL_CONSTRUCTION_CODES:{construction_code:string, symbol_2d_code:string}[] = [];

  //グループ一覧
  _groups:{id:string, item_list:MasterItemCollection[]}[] = [];
  get GROUP():{id:string, item_list:MasterItemCollection[]}[] {
    return this._grades;
  }

  constructor() {
  }

  /**
   * 建物スタイル リストの取得
   *
   */
  getGradesMasterData(resolve: any = null) {
    const self = this;
    const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.get_grades_api_url;
    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then(response => response.json())
      .then((data) => {
        const gradeData = data.grades;
        if (gradeData && gradeData.length > 0) {
          this.GRADES = self.createGradeList(gradeData);
        }
        if (resolve) resolve();
      })
      .catch((error) => {
        console.error(error);
        if (resolve) resolve();
      });
  }

  /**
   * グレード別アイテム引きアイテムリストの取得
   */
  getGradeItemMasterData(id:string, resolve: any = null) {
    const self = this;
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.get_grades_item_api_url}${id}`;
    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then(response => response.json())
      .then((data) => {
        // //マスタデータ一覧として保持
        // marietta.WebCADGlobal.webcad2Dmanager.grade.updateItemList( data.grade_items );
        if (resolve) resolve(data.grade_items);
      })
      .catch((error) => {
        console.error(error);
        if (resolve) resolve();
      });
  }

  /**
   * グループ アイテム リストを取得する
   * （アイテム入れ替えリストを生成用）
   */
  getGroupItemsMasterData(id: string, resolve: any = null) {
    const self = this;
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.get_group_item_api_url}${id}`;
    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then(response => response.json())
      .then((data) => {
        console.log(data);
        if (resolve) resolve(data.group_items);
      })
      .catch((error) => {
        console.error(error);
        if (resolve) resolve();
      });
  }

  /**
   * シンボル アイテム リストを取得する
   * （アイテム入れ替えリストを生成用）
   */
  getSymbolItemsMasterData(id: string, resolve: any = null) {
    const self = this;
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.get_symbol_item_api_url}${id}`;
    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then(response => response.json())
      .then((data) => {
        console.log(data);
        if (resolve) resolve(data.symbol_items);
      })
      .catch((error) => {
        if (resolve) resolve();
      });
  }

  /**
   *リストを作成
   */
  createGradeList(gradeData) {
    const gradeList: GradeMasterCollection[] = [];
    for (let i = 0; i < gradeData.length; i += 1) {
      gradeList.push(new GradeMasterCollection(gradeData[i].id, gradeData[i].name));
    }
    return gradeList;
  }

  /**
   * グレード情報をIDより抽出
   */
  getGradeInfoById( id:string ):GradeMasterCollection{
    return this._grades.find((obj: GradeMasterCollection) => obj.id === id);
  }

  /**
   * グループリストの取得
   */
  getGroupListForId(id:string):{id:string, item_list:MasterItemCollection[]}{
    let retValue:{id:string, item_list:MasterItemCollection[]} = this.GROUP.find((obj) => obj.id == id );
    if( !retValue ) return null;

    return retValue;
  }

  /**
   * リストの取得
   */
  getSymbolConstructionCodes(resolve: any = null) {
    const self = this;
    const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.get_symbol_construction_codes;
    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then(response => response.json())
      .then((data) => {
        const symbolData = data.symbol_construction_codes;
        this.SYMBOL_CONSTRUCTION_CODES = [];
        for (let i:number = 0; i < symbolData.length; i++) {
          this.SYMBOL_CONSTRUCTION_CODES.push(
            {construction_code:symbolData[i].construction_code, symbol_2d_code:symbolData[i].symbol_2d_code}
          );
        }
        if (resolve) resolve();
      })
      .catch((error) => {
        console.error(error);
        if (resolve) resolve();
      });
  }


  /**
   * 2DシンボルID用工事コード取得
   */
  getConstructionCodeForID(code:string = null):string{
    if( !code ) return null;
    let retValue:{construction_code:string, symbol_2d_code:string} = this.SYMBOL_CONSTRUCTION_CODES.find((obj) => obj.symbol_2d_code == code );
    if( !retValue ) return null;

    return retValue.construction_code;
  }

  /**
   * 付帯工事マスタの取得
   */
  public async getAuxiliaryMasterData(): Promise<void> {
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.domain}/api/v1/webcad/auxiliary-constructions`;
    const token = marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token;
    try {
      const res = await fetch(url, { method: 'GET', headers: { Authorization: token } });
      const data = await res.json();
      marietta.webcad.WebCADGlobal.AUXILIARY_MASTER = data;
      console.log('付帯工事マスタ: ', marietta.webcad.WebCADGlobal.AUXILIARY_MASTER);
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * 修繕理由マスタの取得
   */
  public async getRepairMasterData(): Promise<void> {
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.domain}/api/v1/webcad/repair-reasons`;
    const token = marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token;
    try {
      const res = await fetch(url, { method: 'GET', headers: { Authorization: token } });
      const data = await res.json();
      marietta.webcad.WebCADGlobal.REPAIR_MASTER = data;
      console.log('修繕理由マスタ: ', marietta.webcad.WebCADGlobal.REPAIR_MASTER);
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * 付帯工事IDから、カテゴリ名、サブカテゴリ名の取得
   * @param categories
   * @param targetId
   */
  public findCategoryAndSubCategoryById(targetId: string): {
    middle_category_name: string,
    sub_category_name: string
  } | null {
    const categories:auxiliaryMiddleCategory[] = [...marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.company, ...marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.default];
    for (const category of categories) {
      for (const subCategory of category.sub_categories) {
        const foundConstruction = subCategory.auxiliary_constructions.find((construction) => construction.id === targetId);
        if (foundConstruction) {
          return {
            middle_category_name: category.middle_category_name,
            sub_category_name: subCategory.sub_category_name,
          };
        }
      }
    }
    return null;
  }

  /**
   * 付帯工事IDから、カテゴリ名、サブカテゴリ名の取得
   * @param categories
   * @param targetId
   */
  static middleCategoryList():auxiliaryMiddleCategory[] {
    const categories:auxiliaryMiddleCategory[] = [...marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.company, ...marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.default];
    return categories;
  }

  /**
   * 付帯工事IDから、カテゴリ名、サブカテゴリ名の取得
   * @param categories
   * @param targetId
   */
  public getSubCategoryList(targetId: string): {
    middle_category_name: string,
    sub_category_name: string
  } | null {
    const categories:auxiliaryMiddleCategory[] = [...marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.company, ...marietta.webcad.WebCADGlobal.AUXILIARY_MASTER.default];
    for (const category of categories) {
      for (const subCategory of category.sub_categories) {
        const foundConstruction = subCategory.auxiliary_constructions.find((construction) => construction.id === targetId);
        if (foundConstruction) {
          return {
            middle_category_name: category.middle_category_name,
            sub_category_name: subCategory.sub_category_name,
          };
        }
      }
    }
    return null;
  }
}
